import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import { ColorPicker } from 'primereact/colorpicker';
import { useSelector } from 'react-redux';
import { postData } from '@/services/api.service';
import { toast } from 'react-toastify';
import ImageCropper from '@/components/imageCropper/imageCropper';
import { fetchCroppedImage } from '@/utils/constants';
import AIContentWriter from '@/components/AIContentWriter';
import AIImageGenerator from '@/components/AIImageGenerator';
import { setTemplateImages } from '@/core/redux/commonSlice';
import { RootState } from '@/core/redux/store';

function AboutWeEditModal({ themeData, getThemeData }: any) {
  const [checklist, setChecklist] = useState<any>([
    { id: 1, title: '' }, // Initial empty checklist item
  ]);
  const [editData, setEditData] = useState<any>();
  const [activeTab, setActiveTab] = useState(0);
  const [cropImageHeight, setCropImageHeight] = useState('');
  const [cropImageWidth, setCropImageWidth] = useState('');
  const [selectedCropImage, setSelectedCropImage] = useState('');
  const [showCropModal, setShowCropModal] = useState<boolean>(false);
  const [imagedata, setImagedata] = useState<any>(null);

  const dispatch = useDispatch();
  const headerData = useSelector((state: RootState) => state.common.header);
  const templateImages = useSelector((state: RootState) => state.common.templateImages);
  const [template, setTemplate] = useState(headerData?.template);

  const [bannerImages, setBannerImages] = useState<string[]>([]);

  const banner = [
    'assets/home/cateimg1.jpg',
    'assets/home/cateimg2.jpg',
    'assets/home/cateimg3.jpg',
    'assets/home/trustimg4.jpg',
    'assets/home/trustimg2.jpg',
    'assets/home/cateimg1.jpg',
    'assets/home/cateimg2.jpg',
    'assets/home/cateimg3.jpg',
    'assets/home/trustimg4.jpg',
    'assets/home/trustimg2.jpg',
  ];

  const saveJsonData = async () => {
    const payload = {
      cms_json: JSON.stringify(editData),
    };
    try {
      const response = await postData('save_cms_json', payload);
      if (response.status == 200 || response.status == 201) {
        getThemeData();
        toast.success('Theme Updated Successfully');
      }
    } catch (err) {
      console.error(err);
    } finally {
    }
  };
  const handleSection2Change = (e: any) => {
    const { value, name, type, checked } = e.target;
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_4: {
        home: {
          ...prevJsonData.theme_4.home,
          section_4: {
            ...prevJsonData.theme_4.home.section_4,
            [name]: value,
            btn_group: {
              ...prevJsonData.theme_4.home.section_4.btn_group,
              btn1: {
                ...prevJsonData.theme_4.home.section_4.btn_group.btn1,
                [name]: value,
              },
            },
          },
        },
      },
    }));
    // saveJsonDataToFile();
  };
  const handleImageChange = (image: string) => {
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_4: {
        home: {
          ...prevJsonData.theme_4.home,
          section_4: {
            ...prevJsonData.theme_4.home.section_4,
            banner: image,
          },
        },
      },
    }));
  };

  const handleCroppedImage = async (image: any) => {
    setShowCropModal(false);
    setImagedata(image);
    const imageLink = await fetchCroppedImage(image);
    if (imageLink != false) {
      handleImageChange(imageLink);
    }
  };

  const updateImageSectionOne = async (e: any) => {
    const image = e.target.files[0];
    // setCropImageHeight("150");
    // setCropImageWidth("150");
    // setSelectedCropImage(image);
    // setShowCropModal(true);
    if (image instanceof File) {
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = (res: any) => {
        handleCroppedImage(res.target.result);
      };
    }
  };

  // Auto-generate prompt based on about us section context for Banner
  const generateAutoPromptBanner = (): string => {
    const title = editData?.theme_4?.home?.section_4?.title || '';
    const paragraphOne = editData?.theme_4?.home?.section_4?.paragraph_one || '';
    const paragraphTwo = editData?.theme_4?.home?.section_4?.paragraph_two || '';
    
    // Build context-based prompt
    let contextPrompt = 'modern professional image for about us section';
    
    if (title || paragraphOne || paragraphTwo) {
      const contextParts: string[] = [];
      if (paragraphOne) {
        // Extract keywords from paragraph
        const keywords = paragraphOne.split(' ').slice(0, 5).join(' ');
      }
      contextPrompt += `, ${contextParts.join(', ')}`;
    }
    
    // Add banner-specific styling
    contextPrompt += ', clean modern aesthetic, professional photography, suitable for about us section, vibrant colors, high quality, no text, no words, no letters, no typography';
    
    return contextPrompt;
  };

  // Handle AI banner image save
  const handleAIImageSave = (imageUrl: string) => {
    // Set the banner image
    handleImageChange(imageUrl);
    
    // Add to banner images array for slider
    setBannerImages(prevImages => [...prevImages, imageUrl]);
    
    // Update Redux store with the new image in image array
    const templateKey = template ? `template${template}` : 'template4';
    const currentTemplate = templateImages[templateKey] || {};
    const currentImages = currentTemplate.image || [];
    const updatedTemplateImages = {
      ...templateImages,
      [templateKey]: {
        ...currentTemplate,
        image: [...currentImages, { url: imageUrl }],
      },
    };
    dispatch(setTemplateImages(updatedTemplateImages));
  };

  useEffect(() => {
    const checklistData = editData?.theme_4?.home?.section_4?.check_list;
    if (checklistData) {
      setChecklist(checklistData);
    }
  }, [editData]);

  useEffect(() => {
    setEditData(themeData);
  }, [themeData]);

  useEffect(() => {
    if (editData != undefined) {
      setEditData(editData);
    }
  }, [editData]);

  // Load existing template images from Redux store with filtering
  useEffect(() => {
    if (templateImages && typeof templateImages === 'object') {
      const templateKey = template ? `template${template}` : 'template4';
      const currentTemplate = templateImages[templateKey];
      const imageImgs = currentTemplate?.image || [];
      
      // Helper function to load image dimensions
      const loadImageDimensions = async (url: string): Promise<{ url: string; width: number; height: number } | null> => {
        return new Promise((resolve) => {
          const img = new Image();
          img.onload = () => {
            resolve({ url, width: img.width, height: img.height });
          };
          img.onerror = () => {
            resolve(null);
          };
          img.src = url;
        });
      };

      // Load and filter images (square from image array)
      if (Array.isArray(imageImgs) && imageImgs.length > 0) {
        const filterImages = async () => {
          const imagePromises = imageImgs.map((img: any) => loadImageDimensions(img.url));
          const loadedImages = await Promise.all(imagePromises);
          
          // Filter for square images (aspect ratio 0.9-1.1)
          const squareImages = loadedImages
            .filter((img) => {
              if (img === null) return false;
              const aspectRatio = img.width / img.height;
              return aspectRatio >= 0.9 && aspectRatio <= 1.1;
            })
            .map((img) => img!.url);
          
          setBannerImages(squareImages);
        };

        filterImages();
      } else {
        setBannerImages([]);
      }
    } else {
      setBannerImages([]);
    }
  }, [templateImages, template]);

  return (
    <>
      {/* <Draggable> */}
      <div className="modal-dialog modal-lg modal-dialog-centered theme-edit-modal">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Section 4 Theme Edit</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-content modal-body">
            <div className="edit-section">
              <div className="row">
                <div className="col">
                  <div className="mb-3">
                    <label className="form-label">Title</label>
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        name="title"
                        value={editData?.theme_4?.home?.section_4?.title}
                        onChange={handleSection2Change}
                        maxLength={1200}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <div className="mb-3">
                    <div className="d-flex align-items-center mb-2 flex-wrap gap-2">
                      <label className="form-label mb-0 mr-2">
                        Paragraph One
                      </label>
                      <AIContentWriter
                        onContentGenerated={(content) => {
                          handleSection2Change({
                            target: {
                              name: 'paragraph_one',
                              value: content,
                            },
                          });
                        }}
                        contentType="about_us"
                        placeholder="Describe what you want in your paragraph. Example: 'Write about our company mission and values'"
                        context="This is for the about us section paragraph one with max 3 lines"
                      />
                    </div>
                    <textarea
                      className="form-control"
                      name="paragraph_one"
                      value={editData?.theme_4?.home?.section_4?.paragraph_one}
                      onChange={handleSection2Change}
                      maxLength={1200}
                      rows={3}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <div className="mb-3">
                    <div className="d-flex align-items-center mb-2 flex-wrap gap-2">
                      <label className="form-label mb-0 mr-2">
                        Paragraph Two
                      </label>
                      <AIContentWriter
                        onContentGenerated={(content) => {
                          handleSection2Change({
                            target: {
                              name: 'paragraph_two',
                              value: content,
                            },
                          });
                        }}
                        contentType="about_us"
                        placeholder="Describe what you want in your paragraph. Example: 'Write about our commitment to quality and customer satisfaction'"
                        context="This is for the about us section paragraph two with max 3 lines"
                      />
                    </div>
                    <textarea
                      className="form-control"
                      name="paragraph_two"
                      value={editData?.theme_4?.home?.section_4?.paragraph_two}
                      onChange={handleSection2Change}
                      maxLength={1200}
                      rows={3}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md">
                  <div className="mb-3">
                    <label className="form-label">header 1 Color</label>
                    <div className="input-group color-change">
                      <input
                        type="text"
                        className="form-control"
                        name="h2color"
                        value={editData?.theme_4?.home?.section_4?.h2color}
                        onChange={handleSection2Change}
                      />
                      <ColorPicker
                        name="h2color"
                        format="hex"
                        onChange={handleSection2Change}
                        value={editData?.theme_4?.home?.section_4?.h2color}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md">
                  <div className="mb-3">
                    <label className="form-label">paragraph Color</label>
                    <div className="input-group color-change">
                      <input
                        type="text"
                        className="form-control"
                        name="paracolor"
                        value={editData?.theme_4?.home?.section_4?.paracolor}
                        onChange={handleSection2Change}
                      />
                      <ColorPicker
                        name="paracolor"
                        format="hex"
                        onChange={handleSection2Change}
                        value={editData?.theme_4?.home?.section_4?.paracolor}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <div className="mb-1">
                    <div className="row">
                      <div className="col-md-12">
                        <label className="form-label">Banner Image</label>
                        <div className="img-bg active">
                          <img
                            src={editData?.theme_4?.home?.section_4?.banner}
                            alt={`Card Icon`}
                          />
                        </div>
                        <div className="img-options">
                          <div className="row">
                            <div className="col-md-12">
                              {bannerImages.length > 0 ? (
                                <Swiper
                                  spaceBetween={15}
                                  navigation={true}
                                  modules={[Navigation]}
                                  breakpoints={{
                                    640: {
                                      slidesPerView: 1,
                                    },
                                    768: {
                                      slidesPerView: 4,
                                    },
                                    1024: {
                                      slidesPerView: 6,
                                    },
                                  }}
                                  className="homejson-slider"
                                >
                                  {bannerImages.map((imageUrl: string, idx: number) => {
                                    return (
                                      <SwiperSlide key={idx}>
                                        <div
                                          className="img-option"
                                          onClick={() =>
                                            handleImageChange(imageUrl)
                                          }
                                        >
                                          <img
                                            src={imageUrl}
                                            alt="Hero Image"
                                            className="img-fluid"
                                          />
                                        </div>
                                      </SwiperSlide>
                                    );
                                  })}
                                </Swiper>
                              ) : (
                                <div className="empty-slider-state text-center py-4">
                                  <div className="empty-state-content">
                                    <i className="fas fa-images fa-3x text-muted mb-3"></i>
                                    <h6 className="text-muted mb-2">No Images Available</h6>
                                    <p className="text-muted small mb-3">
                                      Generate AI images or upload your own to see them here
                                    </p>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* AI Image Generator */}
              <AIImageGenerator
                generateAutoPrompt={generateAutoPromptBanner}
                onSave={handleAIImageSave}
                imageType="image"
                defaultWidth="1024"
                defaultHeight="1024"
                title="AI Image"
                autoGenerate={true}
                template={template}
              />

              <div className="row">
                <div className="col">
                  <div className="mb-3">
                    <label className="form-label">Upload Image</label>
                    <input
                      type="file"
                      accept="image/png, image/jpeg"
                      className="form-control"
                      name="image"
                      onChange={updateImageSectionOne}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="edit-section d-none">
              <div className="row">
                <div className="col">
                  <div className=" mb-3">
                    <label className="form-label">Button 1</label>
                    <input
                      type="text"
                      className="form-control"
                      name="text"
                      value={
                        editData?.theme_4?.home?.section_4?.btn_group?.btn1
                          ?.text
                      }
                      onChange={handleSection2Change}
                    />
                  </div>
                </div>
                <div className="col">
                  <div className="mb-3">
                    <label className="form-label">Bg Color</label>
                    <div className="input-group color-change">
                      <input
                        type="text"
                        className="form-control"
                        name="bg_color"
                        value={
                          editData?.theme_4?.home?.section_4?.btn_group?.btn1
                            ?.bg_color
                        }
                        style={{
                          background: `#${editData?.theme_4?.home?.section_4?.btn_group?.btn1?.bg_color}`,
                        }}
                        onChange={handleSection2Change}
                        maxLength={250}
                      />
                      <ColorPicker
                        name="bg_color"
                        onChange={(e) => {
                          handleSection2Change(e);
                        }}
                        format="hex"
                        value={
                          editData?.theme_4?.home?.section_4?.btn_group?.btn1
                            ?.bg_color
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="col">
                  <div className=" mb-3">
                    <label className="form-label">Color</label>
                    <div className="input-group color-change">
                      <input
                        type="text"
                        className="form-control"
                        name="color"
                        value={
                          editData?.theme_4?.home?.section_4?.btn_group?.btn1
                            ?.color
                        }
                        style={{
                          background: `${editData?.theme_4?.home?.section_4?.btn_group?.btn1?.color}`,
                        }}
                        onChange={handleSection2Change}
                      />
                      <ColorPicker
                        name="color"
                        onChange={(e) => {
                          handleSection2Change(e);
                        }}
                        format="hex"
                        value={
                          editData?.theme_4?.home?.section_4?.btn_group?.btn1
                            ?.color
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="edit-section">
              <div className="row">
                <div className="col">
                  <div className="mb-3">
                    <label className="form-label">Option One</label>
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        name="option_one"
                        value={editData?.theme_4?.home?.section_4?.option_one}
                        onChange={handleSection2Change}
                        maxLength={1200}
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Option Two</label>
                      <input
                        type="text"
                        className="form-control"
                        name="option_two"
                        value={editData?.theme_4?.home?.section_4?.option_two}
                        onChange={handleSection2Change}
                        maxLength={1200}
                      />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Option Three</label>
                      <input
                        type="text"
                        className="form-control"
                        name="option_three"
                        value={editData?.theme_4?.home?.section_4?.option_three}
                        onChange={handleSection2Change}
                        maxLength={1200}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="mb-3">
              <button
                type="submit"
                data-bs-dismiss="modal"
                className="btn primary-btn"
                onClick={() => {
                  saveJsonData();
                }}
              >
                Save Changes
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* </Draggable> */}
      {showCropModal ? (
        <>
          <div
            className="modal modal-sm-crop fade show onboarding-modal settings cropModal"
            id="crop-modal"
            tabIndex={-1}
            aria-labelledby="crop-modal"
            aria-hidden="true"
            style={{ display: 'block' }}
          >
            <ImageCropper
              src={selectedCropImage}
              height={cropImageHeight}
              width={cropImageWidth}
              handleCrop={handleCroppedImage}
              close={() => {
                setShowCropModal(false);
              }}
            />
          </div>
        </>
      ) : null}
    </>
  );
}

export default AboutWeEditModal;
